import { useSelector } from 'react-redux';

import PrivateRoute from 'containers/PrivateRoute';
import { canManageMarketingCampaigns } from '../utils/marketingCampaignPermissions';

import { InitialSetupCheckProvider } from '../hooks/InitialSetupCheckContext';
import SetupCheckerWrapper from './SetupCheckerWrapper';

export const MarketingManagementGuard = ({ children }) => {
    const isAllowed = useSelector(canManageMarketingCampaigns);

    return (
        <PrivateRoute isAllowed={isAllowed} redirectTo="/">
            {children}
        </PrivateRoute>
    );
};

const MarketingManagementRoute = ({ children }) => (
    <MarketingManagementGuard>
        <InitialSetupCheckProvider>
            <SetupCheckerWrapper>{children}</SetupCheckerWrapper>
        </InitialSetupCheckProvider>
    </MarketingManagementGuard>
);

export default MarketingManagementRoute;
